module.exports = __webpack_public_path__ + "static/media/new-label.c82ce41f.svg";